import { ExternalLinks } from './external-links';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from '@/shared/ui/icons';

export const SocialNetworks = [
  {
    name: 'facebook',
    url: ExternalLinks.footer.facebook,
    icon: FacebookIcon,
  },
  {
    name: 'instagram',
    url: ExternalLinks.footer.instagram,
    icon: InstagramIcon,
  },
  {
    name: 'linkedin',
    url: ExternalLinks.footer.linkedin,
    icon: LinkedinIcon,
  },
];
